import React from 'react';

export const IconArrowRight = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M1.29289322,0.292893219 C1.65337718,-0.0675907428 2.22060824,-0.0953202783 2.61289944,0.209704612 L2.70710678,0.292893219 L7.70710678,5.29289322 C8.06759074,5.65337718 8.09532028,6.22060824 7.79029539,6.61289944 L7.70710678,6.70710678 L2.70710678,11.7071068 C2.31658249,12.0976311 1.68341751,12.0976311 1.29289322,11.7071068 C0.932409257,11.3466228 0.904679722,10.7793918 1.20970461,10.3871006 L1.29289322,10.2928932 L5.585,6 L1.29289322,1.70710678 C0.932409257,1.34662282 0.904679722,0.779391764 1.20970461,0.387100557 L1.29289322,0.292893219 Z"
			/>
		</svg>
	);
};
